






































































































import {Component} from 'vue-property-decorator';
import Webreport from '@/webreport/Webreport';

import CashflowV2 from '@/charts/CashFlow_v2.vue';
import DynamicColumnChart from '@/charts/DynamicColumnChart.vue';
import DynamicLineChart from '@/charts/DynamicLineChart.vue';
import CashflowAnalysis from '@/webreport/components/CashflowAnalysis.vue';

@Component({
  components: {
    CashflowV2,
    DynamicColumnChart,
    DynamicLineChart,
    CashflowAnalysis},
})
export default class Cashflow extends Webreport {
  async mounted() {
    await this.loadDocument();
  }

  created() {
    const el: any = document.body;
    el.parentElement.classList.add('webreport');
  }

  destroyed() {
    const el: any = document.body;
    el.parentElement.classList.remove('webreport');
  }

  get isPreview() {
    return this.$route.query.preview === 'true';
  }

  get comment() {
    if (this.doc.doc.Texts) {
      return this.doc.doc.Texts[`webreport_cashflow_comment`];
    }
    return undefined;
  }

  isActive(section: any) {
    const years = this.doc.cashflow.count;
    switch (section) {
      case 'recievedOwnerCapital':
        for (let i = 0; i < years; i++) {
            // tslint:disable:max-line-length
          if (this.doc.cashflow.sheets[i].EquityWithoutNetProfitDelta + this.doc.cashflow.sheets[i].SubscribedCapitalUnpaidDelta > 0) {
            return true;
          }
        }
        return false;
      case 'hasMadeInvestments':
        for (let i = 0; i < years; i++) {
          if (this.doc.cashflow.sheets[i].InvestmentsCashflow !== 0) {
            return true;
          }
        }
        return false;
      case 'hasLoans':
        for (let i = 0; i <= years; i++) {
          if ((this.doc.balance.sheets[i].U + this.doc.balance.sheets[i].P) > 0) {
            return true;
          }
        }
        return false;
      case 'hasDividend':
        for (let i = 0; i < years; i++) {
          if (this.doc.cashflow.sheets[i].EquityWithoutNetProfitDelta < 0) {
            return true;
          }
        }
        return false;
      case 'hasError':
        for (let i = 0; i < years; i++) {
          if (this.doc.cashflow.sheets[i].CashFlowError !== 0) {
            return true;
          }
        }
        return false;
      case 'hasnot12months':
        for (let i = 0; i <= years; i++) {
          if (this.doc.balance.sheets[i].MONTHS !== '12') {
            return true;
          }
        }
        return false;
      case 'notCorrectWorkingCapital':
        for (let i = 0; i < years; i++) {
            // tslint:disable:max-line-length
          if ( ((this.doc.balance.sheets[i].K - this.doc.balance.sheets[i].J - this.doc.balance.sheets[i].Q + this.doc.balance.sheets[i].U) - (this.doc.balance.sheets[i + 1].K - this.doc.balance.sheets[i + 1].J - this.doc.balance.sheets[i + 1].Q + this.doc.balance.sheets[i + 1].U)) + this.doc.cashflow.sheets[i].WorkingCaptialCashflow !== 0) {
            return true;
          }
        }
        return false;
      case 'almostCorrectWorkingCapital':
        for (let i = 0; i < years; i++) {
            // tslint:disable:max-line-length
          if ( Math.abs(((this.doc.balance.sheets[i].K - this.doc.balance.sheets[i].J - this.doc.balance.sheets[i].Q + this.doc.balance.sheets[i].U) - (this.doc.balance.sheets[i + 1].K - this.doc.balance.sheets[i + 1].J - this.doc.balance.sheets[i + 1].Q + this.doc.balance.sheets[i + 1].U)) + this.doc.cashflow.sheets[i].WorkingCaptialCashflow) < 3) {
            return true;
          }
        }
        return false;
      case 'hasnotSameToDate':
        const toDate = this.doc.balance.sheets[0].DATE_TO.slice(5, 10);
        for (let i = 0; i <= years; i++) {
          if (this.doc.balance.sheets[i].DATE_TO.slice(5, 10) !== toDate) {
            return true;
          }
        }
        return false;
    }
  }

}

